/**
 * useFriends Hook (Web)
 * Thin wrapper around shared useFriends
 */

import { useAuth } from '@contexts/AuthContext';
import { createHttpClient } from '@parlay-picker/shared/api/httpClient';
import { type UseFriendsResult, useFriends as useFriendsShared } from '@parlay-picker/shared/hooks';
import { useMemo } from 'react';
import { API_BASE_URL } from '../config/api';

export type { UseFriendsResult };

export function useFriends(): UseFriendsResult {
  const { isAuthenticated, authFetch } = useAuth();

  const httpClient = useMemo(
    () => createHttpClient({ authFetch, baseUrl: API_BASE_URL }),
    [authFetch],
  );

  return useFriendsShared({ httpClient, isAuthenticated });
}
